import nBossConnection from 'modules/base/service/nBossConnection';
import _ from '@lodash';
import * as yup from 'yup';
import { useHistory } from 'react-router';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch } from 'react-redux';
// import { showMessage } from 'app/store/fuse/messageSlice';
import { useForm, FormProvider, Controller } from 'react-hook-form';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, IconButton } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { FaFileCsv, FaFileExcel, FaChartLine } from 'react-icons/fa';

import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';

import OptimizerLogTableService from 'app/admin/optimizerLog/service/OptimizerLogTableService';

export function OptimizerLogRunsAndTrajectoriesDialog(props) {
    const history = useHistory();
    const { t } = useTranslation(['common']);
    // const dispatch = useDispatch();

    const schema = yup.object().shape({
        run: yup.string().nullable().required(t('validation:FIELD_REQUIRED'))
    });

    const getDefaultValues = () => {
        let defaultValues = {};
        return defaultValues;
    };

    const methods = useForm({
        defaultValues: getDefaultValues(),
        mode: 'onChange',
        resolver: yupResolver(schema)
    });

    const run = methods.watch('run');

    const handleCancel = () => {
        props.onCancel();
    };

    const exportByType = (typeMethod) => {
        window.open(`${nBossConnection.basePath}optimizerLogTableControl/${typeMethod}?name=${props.name}&runId=${methods.getValues('run')}`);
    };

    const handleTrajectory = () => {
        OptimizerLogTableService.getTrajectory(props.name, methods.getValues('run')).then(response => {
            console.log(response);
        }).catch(err => {
            console.log(err);
        });
    };

    return (
        <Dialog open fullWidth>

            <DialogTitle disableTypography className='border-b'>
                Optimizer log for {props.name}
            </DialogTitle>

            <DialogContent className='p-20'>

                <div className='flex items-center gap-8'>
                    <FormProvider {...methods}>
                        <Controller
                            control={methods.control}
                            name='run'
                            render={({ field, fieldState }) => (
                                <EditFormSelectField
                                    field={field}
                                    fieldState={fieldState}
                                    config={{ topic: 'common' }}
                                    fieldConfig={{
                                        key: 'run',
                                        text: 'Run',
                                        items: () => OptimizerLogTableService.getRuns(props.name)
                                    }}
                                />
                            )}
                        />
                    </FormProvider>

                    <div className='flex gap-8 mt-8 mb-16'>
                        <IconButton disabled={!run} onClick={() => handleTrajectory()}><FaChartLine fontSize='medium' /></IconButton>
                        <IconButton disabled={!run} onClick={() => exportByType('exportTrajectoryToCsv')}><FaFileCsv fontSize='medium' /></IconButton>
                        <IconButton disabled={!run} onClick={() => exportByType('exportTrajectoryToXlsx')}><FaFileExcel fontSize='medium' /></IconButton>
                    </div>

                </div>

            </DialogContent>

            <DialogActions className='justify-between border-t p-20'>

                {/* <Button onClick={() => { handleCancel(); }}>{t('CANCEL')}</Button> */}

                <Button onClick={() => { handleCancel(); }} color='primary' autoFocus>
                    Close
                </Button>

            </DialogActions>

        </Dialog >
    );
}
export default OptimizerLogRunsAndTrajectoriesDialog;
